module.exports = __webpack_public_path__ + "static/media/sms.6b2ded3b.svg";